import { get } from 'lodash';
import React, { FC } from 'react';
import { FOERDERPROGRAMM_ERKLAERUNG_UND_UNTERLAGEN_MA_PATHS } from 'src/lib/constants/componentsPath';

// import schemas
import { concat } from 'lodash';
import CreateForm from 'src/components/ui-component/form-component/create-form/CreateForm';
import { useApplication } from 'src/context/ApplicationContext';
import { ANTRAGS_FORMULAREN, FORM_FIELDS_TYPES } from 'src/lib/constants/constant';
import MASchema from 'src/lib/paths/mittelabruf_FULL_Paths.json';
import { FormStrucItem } from 'src/lib/types/types';
import { getTextFieldValidationByDatei } from 'src/lib/validation/fieldValidationHelper';
import ApplicationHeading from 'src/pages/private/online-antrag/application-heading/ApplicationHeading';
import { mapindexbyPath } from 'src/utils/formStruc';
import { addIndexToPath } from 'src/utils/helper';
const P = MASchema.attributes;

const SonstigeAnlagenMA: FC<{}> = () => {
	const { application, setApplicationProperty, readOnly } = useApplication();

	const foerderprogramm = get(application, P.Foerderantrag.schema.attributes.Foerderprogramm.path, {});
	const paths = FOERDERPROGRAMM_ERKLAERUNG_UND_UNTERLAGEN_MA_PATHS;
	return (
		<>
			<ApplicationHeading
				title={get(foerderprogramm, paths.SontigeAnlageUnterTitel, 'Sonstige Anlagen')}
				description={get(foerderprogramm, paths.SontigeAnlageBeschreibung, '')}
			/>

			<CreateForm
				formStruc={formStrucSonstigeAnlagen()}
				formValues={application}
				updateFormValuesFunc={setApplicationProperty}
				readOnly={readOnly}
			/>
		</>
	);
};

export default SonstigeAnlagenMA;

const formStrucSonstigeAnlagen = () => {
	let struc: FormStrucItem[] = [
		{
			fields: [
				{
					...P.Anlagen_Sonstige_Anlagen,
					type: FORM_FIELDS_TYPES.editableTable,
					fieldProps: { Bezeichnung_Des_Dokuments: { width: '15rem' } },
				},
			],
			userProps: { columnToDivide: 1 },
		},
	];
	return struc;
};

const customFormStrucSonstigeAnlagen = (application: any, i: number): FormStrucItem[] => {
	const hatAnlage = get(application, addIndexToPath(P.Anlagen_Sonstige_Anlagen.schema.attributes.Datei.path, i, P.Anlagen_Sonstige_Anlagen.path));
	let struc: FormStrucItem[] = [
		{
			fields: [
				{
					...P.Anlagen_Sonstige_Anlagen.schema.attributes.Bemerkungen_Zum_Dokument,
					validation: getTextFieldValidationByDatei(hatAnlage),
				},
				{
					...P.Anlagen_Sonstige_Anlagen.schema.attributes.Bezeichnung_Des_Dokuments,
					validation: getTextFieldValidationByDatei(hatAnlage),
				},
			],
		},
	];
	return struc;
};

export const getFormStrucSonstigeAnlagenMA = (application: any) => {
	const antragsFormular = get(application, P.Foerderantrag.schema.attributes.Allgemein_Antragsformular.path, '');
	switch (antragsFormular) {
		case ANTRAGS_FORMULAREN.Loewe:
			const anlagenLength = get(application, P.Anlagen_Sonstige_Anlagen.path, []).length;
			let result: FormStrucItem[] = [];
			for (let i = 0; i < anlagenLength; i++) {
				const customFormStrucWithIndex = mapindexbyPath(customFormStrucSonstigeAnlagen(application, i), i, P.Anlagen_Sonstige_Anlagen);
				result = concat(result, customFormStrucWithIndex);
			}
			return result;
		default:
			return [];
	}
};
